import toast from 'react-hot-toast';

export const copyToClipboard = async (text: string, successMessage = 'متن با موفقیت کپی شد!') => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = text;
    const textToCopy = tempElement.textContent || tempElement.innerText;
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(textToCopy);
            toast.success(successMessage);
        } else {
            const textArea = document.createElement('textarea');
            textArea.value = textToCopy;
            textArea.style.position = 'fixed';
            textArea.style.left = '-9999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);
            if (successful) {
                toast.success('متن با موفقیت کپی شد!');
            } else {
                throw new Error('عملیات کپی ناموفق بود');
            }
        }
    } catch {
        toast.error('خطا در کپی کردن متن');
    }
};

